import { render } from "./UserTeamPage.vue?vue&type=template&id=53ca5aa7&ts=true"
import script from "./UserTeamPage.vue?vue&type=script&lang=ts"
export * from "./UserTeamPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__